var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12.9167C1.5 12.9167 4.67442 11.4464 5.88372 10.6726C5.32415 9.76554 3.9878 8.34001 3.79165 5.79762M14.5 12.9167C14.5 12.9167 11.3256 11.4464 10.1163 10.6726C10.6759 9.81319 12.0125 8.34664 12.2084 5.79762M3.79165 5.79762C3.77584 5.5928 3.76744 5.38626 3.76744 5.17857C3.76744 2.08333 6.03488 1 8 1C9.96512 1 12.2326 2.08333 12.2326 5.17857C12.2326 5.38599 12.2242 5.59255 12.2084 5.79762M3.79165 5.79762C3.93474 5.33333 4.61395 4.40476 5.5814 4.40476C6.7907 4.40476 6.63953 5.79762 8 5.79762C9.36047 5.79762 9.36047 4.40476 10.4186 4.40476C11.2651 4.40476 12.1661 5.33333 12.2084 5.79762",
    stroke: "#ABBACE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignMan);
export default __webpack_public_path__ + "static/media/signMan.a98e6d877cfc700731e937f72ca3021f.svg";
export { ForwardRef as ReactComponent };